'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createPlatform;
function createPlatform() {
    var fixture = null;

    return {
        setWeb: function setWeb() {
            fixture = 'web';
            return this;
        },
        setMobileWeb: function setMobileWeb() {
            fixture = 'mobileweb';
            return this;
        },
        setMessenger: function setMessenger() {
            fixture = 'com.messenger';
            return this;
        },
        setTelegram: function setTelegram() {
            fixture = 'com.telegram';
            return this;
        },
        setSlack: function setSlack() {
            fixture = 'com.slack';
            return this;
        },
        val: function val() {
            return fixture;
        }
    };
}